module.exports = __webpack_public_path__ + "static/media/linee_small.1fd21390.svg";